// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3o5f3","selected":"Chip_selected__2_jCs"};